import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import { days_to_ms } from '../util/general_util';
import { Trip_v2 } from '../util/tripPlanner_types';

const stopCalenderColor = "#2a2550";
const stayCalendarColor = "#f48231";
const poiCalendarColor = "#ca6f2e";

// function calendar_setEventColor_byTitle(calendar:Calendar|null, title:string, color:string) {
//     if (calendar === null || calendar === undefined) return;
//     let events = calendar.getEvents();
//     for (let i:number = 0; i < events.length; i++) {
//         if (events[i].title == title) {
//             events[i].setProp("backgroundColor", color);
//         };
//     };
// };

// function calendar_addOrUpdateEvent(calendar:Calendar|null, event:{title:string,backgroundColor?:string,extendedProps?:any,start:string,end?:string}|{title:string,extendedProps?:any,date:string}) {
//     if (calendar === null || calendar === undefined) return;
//     let events = calendar.getEvents();
//     for (let i:number = 0; i < events.length; i++) {
//         if (events[i].title == event.title) {
//             if ("start" in event) {
//                 events[i].setStart(event.start);
//                 events[i].setEnd(event.end);
//             } else {
//                 events[i].setStart(event.date);
//             };
//             return;
//         };
//     };
//     calendar.addEvent(event);
// };

function calendar_getEarliestEventDate(calendar:Calendar|null):Date|null {
    if (calendar === null || calendar === undefined) return null;
    let events = calendar.getEvents();
    let minDate:Date|null = null
    events.forEach((event:any) => {
        if (event.start === null) return;
        if (!minDate || event.start < minDate) {
            minDate = event.start;
        };
    });

    return (minDate !== null)? new Date(minDate.getFullYear(), minDate.getMonth(), 1): null;
};

function getCalendarEvents(trip: Trip_v2) {
	let i: number, j: number, k: number;
	let events: Array<{ title: string, start: string, end?: string, backgroundColor?: string, extendedProps?: any }> = [];
	for (i = 0; i < trip.legs.length; i++) {
		for (j = 0; j < trip.legs[i].clusters.length; j++) {
			let stop_sdate: Date | undefined | null = trip.legs[i].clusters[j].s_date;
			let stop_nNights: number | undefined | null = trip.legs[i].clusters[j].numNights;
			if (stop_sdate !== undefined && stop_sdate !== null && stop_nNights !== undefined && stop_nNights !== null) {
				if (typeof(stop_sdate) == "string") {
					stop_sdate = new Date(stop_sdate);
				}
				events.push({
					title: trip.legs[i].clusters[j].clusterTitle,
					backgroundColor: stopCalenderColor,
					start: stop_sdate.toISOString(),
					end: new Date(stop_sdate.getTime() + days_to_ms(stop_nNights + 1)).toISOString(),
					extendedProps: { type: "stop" }
				});
			} else {
				for (k = 0; k < trip.legs[i].clusters[j].selectedCamps.length; k++) {
					let stay_sdate: Date | undefined | null = trip.legs[i].clusters[j].selectedCamps[k].s_date;
					let stay_nNights: number | undefined | null = trip.legs[i].clusters[j].selectedCamps[k].numNights;

					if (stay_sdate !== undefined && stay_sdate !== null && stay_nNights !== undefined && stay_nNights !== null) {
						if (typeof(stay_sdate) == "string") {
							stay_sdate = new Date(stay_sdate);
						};
						events.push({
							title: trip.legs[i].clusters[j].selectedCamps[k].camp.camp_name,
							backgroundColor: stayCalendarColor,
							start: stay_sdate.toISOString(),
							end: new Date(stay_sdate.getTime() + days_to_ms(stay_nNights + 1)).toISOString(),
							extendedProps: { type: "stay" }
						});
					}
				};
			};
		};
	};
	return events;
};

function initCalendar(elementID:string, events:any) {
    let calendarEl = document.getElementById(elementID);
    if (calendarEl === null) return null;
    let calendar:Calendar = new Calendar(calendarEl, {
        plugins: [dayGridPlugin],
        initialView: 'dayGridMonth',
        events: events,
        displayEventTime: false,
        eventOrder: function(a:any,b:any) {
            const typeOrder:any = {
                "stop": 1,
                "stay": 2,
                "poi": 3
            };
            return typeOrder[a.extendedProps.type] - typeOrder[b.extendedProps.type];
        }
    });
    return calendar;
};

export function open_calendar() {
    if (window.tripCalendar) window.tripCalendar.destroy();

    const events = getCalendarEvents(window.tripPlannerCurrentTrip);

    window.tripCalendar = initCalendar("tripCalendarEl", events);

    let earliestDate:Date|null = calendar_getEarliestEventDate(window.tripCalendar);

    if (earliestDate !== null) window.tripCalendar?.gotoDate(earliestDate);

    $("#calendarModal").modal("show");
};